module.exports = __webpack_public_path__ + "media/images/lb/121-e4395754ee195876dace0ca46fa57dad.svg";